/*
 * Survol des cartes produit Horizon (pages collection, recherche, panier) :
 * la deuxieme prise de vue, le bijou porte, se fond par-dessus la premiere.
 *
 * Horizon pose bien on:pointerenter="/previewImage" sur .card-gallery, mais le
 * comportement ne se declenche pas ici : un pointerenter ne change aucune
 * diapositive tant que card_hover_effect vaut "none". Plutot que de piloter
 * son carrousel, et d'entrer en conflit avec lui, on superpose notre propre
 * image, ce qui laisse le composant intact.
 * Les grilles maison (co-pieces, co-related) gerent leur survol en CSS.
 *
 * 27.09 : si la carte porte data-co-survol (metachamp custom.image_survol),
 * cette photo dediee est utilisee au survol a la place de la 2e photo.
 * Si elle porte data-co-carte (metachamp custom.image_carte, fichier absent de
 * la fiche), cette photo remplace la 1re image de la carte.
 */
(function () {
  var SEL = '.card-gallery';

  function decorate(gallery) {
    if (gallery.dataset.coHover) return;

    var card = gallery.closest('product-card');
    var carte = card && card.dataset.coCarte;
    var survol = card && card.dataset.coSurvol;
    var first = gallery.querySelector('img');

    if (carte && first && !first.dataset.coCarte) {
      first.dataset.coCarte = '1';
      first.removeAttribute('srcset');
      if (card.dataset.coCarteSet) first.setAttribute('srcset', card.dataset.coCarteSet);
      first.setAttribute('src', carte);
    }

    var src = '';
    var srcset = '';
    var sizes = '';

    if (survol) {
      src = survol;
      srcset = card.dataset.coSurvolSet || '';
      if (first && first.getAttribute('sizes')) sizes = first.getAttribute('sizes');
    } else {
      var imgs = gallery.querySelectorAll('img');
      if (imgs.length < 2) return;
      var second = imgs[1];
      src = second.currentSrc || second.getAttribute('src') || '';
      srcset = second.getAttribute('srcset') || '';
      sizes = second.getAttribute('sizes') || '';
    }
    if (!src && !srcset) return;

    gallery.dataset.coHover = '1';

    var overlay = document.createElement('img');
    overlay.className = 'co-hover-img';
    overlay.alt = '';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.loading = 'lazy';
    overlay.decoding = 'async';
    if (srcset) overlay.srcset = srcset;
    if (sizes) overlay.sizes = sizes;
    if (src) overlay.src = src;

    gallery.appendChild(overlay);
  }

  // Noms accessibles que l'en-tete d'Horizon ne pose pas : le bouton du menu
  // mobile et le lien du logo sont annonces "bouton" et "lien" sans cela.
  function labelHeader() {
    var menu = document.querySelector('header button[aria-controls], header button[class*="menu"]');
    if (menu && !menu.getAttribute('aria-label')) menu.setAttribute('aria-label', 'Menu');
    var logo = document.querySelector('header a[href="/"], header a[href="/de"], header a[href="/en"], header a[href="/fr"]');
    if (logo && !logo.getAttribute('aria-label')) logo.setAttribute('aria-label', 'Carron Olivier, accueil');
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SEL).forEach(decorate);
  }

  function init() { scan(); labelHeader(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Les filtres, la pagination et le rendu de section reinjectent des cartes.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SEL)) decorate(node);
        else scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();